import { Typography } from "antd";

interface TextEllipsisProps {
  text: string;
  rows?: number;
}

const TextEllipsis = ({ text, rows = 2 }: TextEllipsisProps) => {
  return (
    <Typography.Paragraph
      ellipsis={{
        rows,
        expandable: false,
        tooltip: text,
      }}
      style={{ marginBottom: 0 }}
    >
      {text}
    </Typography.Paragraph>
  );
};

export default TextEllipsis;
